import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/maintenance`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const saveSettings = body => axios.put(`${base}/settings`, body, headers());
export const getOverview = () => axios.get(`${base}/overview`, headers());
export const planNow = () => axios.post(`${base}/plan`, {}, headers());

export const createTemplate = body => axios.post(`${base}/templates`, body, headers());
export const updateTemplate = (id, body) => axios.put(`${base}/templates/${id}`, body, headers());
export const deleteTemplate = id => axios.delete(`${base}/templates/${id}`, headers());

export const listInstallations = filters =>
  axios.post(`${base}/installations/list`, filters, headers());
export const getInstallation = id => axios.get(`${base}/installations/${id}`, headers());
export const createInstallation = body => axios.post(`${base}/installations`, body, headers());
export const updateInstallation = (id, body) =>
  axios.put(`${base}/installations/${id}`, body, headers());
export const deleteInstallation = id => axios.delete(`${base}/installations/${id}`, headers());
export const deleteInstallationFile = (id, fileId) =>
  axios.delete(`${base}/installations/${id}/files/${fileId}`, headers());
export const uploadInstallationFile = (id, blob, name, caption) => {
  const body = new FormData();
  body.append("file", blob, name);
  if (caption) body.append("caption", caption);
  return axios.post(`${base}/installations/${id}/files`, body, headers());
};

export const listContracts = filters => axios.post(`${base}/contracts/list`, filters, headers());
export const getContract = id => axios.get(`${base}/contracts/${id}`, headers());
export const createContract = body => axios.post(`${base}/contracts`, body, headers());
export const updateContract = (id, body) => axios.put(`${base}/contracts/${id}`, body, headers());
export const deleteContract = id => axios.delete(`${base}/contracts/${id}`, headers());
export const activateContract = id => axios.post(`${base}/contracts/${id}/activate`, {}, headers());
export const terminateContract = (id, body) =>
  axios.post(`${base}/contracts/${id}/terminate`, body, headers());

export const listVisits = filters => axios.post(`${base}/visits/list`, filters, headers());
export const getVisit = id => axios.get(`${base}/visits/${id}`, headers());
export const createVisit = body => axios.post(`${base}/visits`, body, headers());
export const updateVisit = (id, body) => axios.put(`${base}/visits/${id}`, body, headers());
export const addProtocol = (id, body) =>
  axios.post(`${base}/visits/${id}/protocols`, body, headers());
export const removeProtocol = (id, protocolId) =>
  axios.delete(`${base}/visits/${id}/protocols/${protocolId}`, headers());
export const completeVisit = (id, body) =>
  axios.post(`${base}/visits/${id}/complete`, body, headers());
export const reopenVisit = (id, body) => axios.post(`${base}/visits/${id}/reopen`, body, headers());
export const cancelVisit = (id, body) => axios.post(`${base}/visits/${id}/cancel`, body, headers());
export const emailVisit = (id, body) => axios.post(`${base}/visits/${id}/email`, body, headers());
export const createDefectOffer = id =>
  axios.post(`${base}/visits/${id}/defect-offer`, {}, headers());
export const invoiceVisits = ids => axios.post(`${base}/visits/invoice`, { ids }, headers());
export const deletePhoto = (id, photoId) =>
  axios.delete(`${base}/visits/${id}/photos/${photoId}`, headers());
export const uploadPhoto = (id, blob, { caption, protocol, itemKey }) => {
  const body = new FormData();
  body.append("photo", blob, blob.type === "image/png" ? "photo.png" : "photo.jpg");
  if (caption) body.append("caption", caption);
  if (protocol) body.append("protocol", protocol);
  if (itemKey) body.append("itemKey", itemKey);
  return axios.post(`${base}/visits/${id}/photos`, body, headers());
};

// Links that open in a new tab or an <img> cannot send a header: the token goes in the query.
const q = () => `token=${encodeURIComponent(token() || "")}`;
export const visitPdfUrl = (id, lng) =>
  `${base}/visits/${id}/pdf?${q()}&lng=${encodeURIComponent(lng === "en" ? "en" : "de")}`;
export const contractPdfUrl = id => `${base}/contracts/${id}/pdf?${q()}`;
export const photoUrl = (id, photoId) => `${base}/visits/${id}/photos/${photoId}?${q()}`;
export const installationFileUrl = (id, fileId) =>
  `${base}/installations/${id}/files/${fileId}?${q()}`;
